import { Page } from '@/components/layout/page/page.tsx'

export const TaskListPageSkeleton = () => {
  return (
    <Page>
      <div className="bg-skeleton animate-pulse w-[100px] h-[20px] rounded-lg mb-2" />
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 mb-3">
        <div className="bg-skeleton animate-pulse w-[130px] h-[30px] rounded-lg" />
        <div className="flex items-center gap-3">
          <div className="bg-skeleton animate-pulse w-[200px] h-[40px] rounded-lg" />
          <div className="bg-skeleton animate-pulse w-[80px] h-[40px] rounded-lg" />
          <div className="bg-skeleton animate-pulse w-[40px] h-[40px] rounded-lg" />
        </div>
      </div>
      <div className="bg-skeleton animate-pulse w-full h-[400px] rounded-lg mb-2" />
    </Page>
  )
}
